exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EmbedConfigurator-803fb919{display:flex;border-bottom:1px solid #DEDEDE}.EmbedConfigurator-803fb919 h1,.EmbedConfigurator-803fb919 h2,.EmbedConfigurator-803fb919 h3,.EmbedConfigurator-803fb919 h4,.EmbedConfigurator-803fb919 h5,.EmbedConfigurator-803fb919 h6{text-transform:none;line-height:1}.LeftPanel-653f9b89{flex:1;min-width:0;padding:40px 2em 2em 2em;background:#f5f5f5}.LeftPanel-653f9b89 pre .embedCode-78830089{white-space:pre-wrap;width:100%;height:100px}.Preview-1d99174e{flex:2;min-width:0;margin:40px 100px 100px 15px}\n", ""]);

// Exports
exports.locals = {
	"EmbedConfigurator": "EmbedConfigurator-803fb919",
	"LeftPanel": "LeftPanel-653f9b89",
	"embedCode": "embedCode-78830089",
	"Preview": "Preview-1d99174e"
};